import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

const slice = (state: RootState) => state.project;

// Section list
export const projectSectionsQuery = createSelector(slice, (state) => state.projectSections);
export const loadingProjectSectionsQuery = createSelector(slice, (state) => state.resetProjectSectionsOngoing);

// Selection
export const selectedProjectSectionsQuery = createSelector(slice, (state) =>
    state.projectSections.filter((projectSection) => state.selectedProjectSectionIds.includes(projectSection.id)),
);
export const selectedProjectSectionIdsQuery = (state) =>
    selectedProjectSectionsQuery(state).map((projectSection) => projectSection.id);

// Sorting
export const projectSectionsSortQuery = createSelector(slice, (state) => state.sort);

// Filtering
export const projectSectionsFilterQuery = createSelector(slice, (state) => state.filter);

// Pagination
export const projectSectionsPaginationQuery = createSelector(slice, (state) => state.pagination);

// Column visibility
export const projectSectionsColumnVisibilityQuery = createSelector(slice, (state) => state.columnVisibility);

// Current project
export const currentProjectIdQuery = createSelector(slice, (state) => state.currentProjectId);
